import React from "react";
import "../styles/button.css";
import googlePlayLogo from "../assets/icon/playstore.png"; // adjust path as needed

export const PlayStore = () => {
  return (
    <div className="app-button">
      <a
        href="https://play.google.com/store/apps/details?id=com.groceria&pli=1"
        className="button-content flex items-center"
      >
        <div className="flex items-center justify-center w-12 h-12 ml-2">
          <img
            src={googlePlayLogo}
            alt="Google Play Logo"
            className="w-full h-full object-contain"
          />
        </div>
        <div className="flex flex-col items-center">
          <span className="text-xs mr-5">GET IT ON</span>
          <span className="text-base font-semibold whitespace-nowrap mr-5">
            Google Play Store
          </span>
        </div>
      </a>
    </div>
  );
};
